import Vue from 'vue'
import Router from 'vue-router'
import { template2 } from '@/card/router/template2'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/query',
      name: 'query',
      meta: {
        title: '设备查询',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/Query')
    },
    {
      path: '/query-list/:mobile/:type',
      name: 'QueryList',
      meta: {
        title: '设备列表',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/QueryList')
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        title: 'search',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/Search')
    },
    {
      path: '/search/:appid/:openid',
      name: 'search',
      meta: {
        title: '充值查询',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/Search')
    },
    {
      path: '/bulletin/:appid',
      name: 'bulletin',
      meta: {
        title: '公告',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/bulletin/index')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '充值查询',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/login/index')
    },
    {
      path: '/template1/login',
      name: 'template1_login',
      meta: {
        title: '充值查询',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/login/index')
    },
    {
      path: '/login-list/:mobile',
      name: 'loginList',
      meta: {
        title: '我的卡包',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/login/list')
    },
    {
      path: '/home',
      name: 'index',
      meta: {
        title: '首页',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/home/index')
    },
    {
      path: '/package/index',
      name: 'package/index',
      meta: {
        title: '套餐充值',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/package/index')
    },
    {
      path: '/package/payh5',
      name: 'package/payh5',
      meta: {
        title: '收银台',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/package/payh5')
    },
    {
      path: '/package/indexpay',
      name: 'package/indexpay',
      meta: {
        title: '充值',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/package/indexpay')
    },
    {
      path: '/cert/index/:iccid/:msisdn/:url',
      name: 'cert/index',
      meta: {
        title: '实名认证跳转',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/cert/index')
    },
    {
      path: '/openWeApp/:iccid',
      name: 'cert/openWeApp',
      meta: {
        title: '实名认证跳转',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/cert/openWeApp')
    },
    {
      path: '/order/index',
      name: 'order/index',
      meta: {
        title: '订单确认',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/order/index')
    },
    // {
    //   path: '/packages/log',
    //   name: 'packages',
    //   meta: {
    //     title: '管理系统-已购套餐',
    //     header: true,
    //     bottom: true,
    //     keepAlive: true,
    //     auth: true
    //   },
    //   component: () => import('@/card/views/PackageLogs')
    // },
    {
      path: '/package/info',
      name: 'package/info',
      meta: {
        title: '有效套餐',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/package/info')
    },
    {
      path: '/charge/log',
      name: 'charge/log',
      meta: {
        title: '充值记录',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/charge/log')
    },
    {
      path: '/selfchange',
      name: 'self-change-card',
      meta: {
        title: '自助换卡',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/selfchange')
    },
    {
      path: '/change',
      name: 'change-card',
      meta: {
        title: '换卡',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/change/index')
    },
    {
      path: '/change/:iccid',
      name: 'change-card-iccid',
      meta: {
        title: '急速换卡',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/change/handle')
    },
    {
      path: '/change/query/:iccid',
      name: 'Index',
      meta: {
        title: '换卡查询',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/change/query')
    },
    {
      path: '/change/info/:iccid/:mobile',
      name: 'change-card-info',
      meta: {
        title: '换卡申请记录',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/change/Info')
    },
    {
      path: '/change/query/:iccid',
      name: 'Change',
      meta: {
        title: '换卡申请',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/change/handle')
    },
    {
      path: '/bind/:iccid',
      name: 'bind',
      meta: {
        title: '用户绑定',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: true
      },
      component: () => import('@/card/views/bind/index')
    },
    {
      path: '/help/:iccid',
      name: 'help',
      meta: {
        title: '管理系统-问题反馈',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/Help')
    },
    {
      path: '/problemList',
      name: 'problemList',
      meta: {
        title: '问题汇总',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/ProblemList')
    },
    {
      path: '/userInstructions',
      name: 'userInstructions',
      meta: {
        title: '用户须知',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/UserInstructions')
    },
    {
      path: '/auth/:iccid',
      name: 'auth',
      meta: {
        title: '实名认证',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: true
      },
      component: () => import('@/card/views/Authentication')
    },
    {
      path: '/user/complain',
      name: 'UserComplain',
      meta: {
        title: '我要投诉',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/user/Complain')
    },
    {
      path: '/service/chat',
      name: 'Chat',
      meta: {
        title: '客服001',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/service/Chat')
    },
    {
      path: '/regular/template1',
      name: 'regular',
      meta: {
        title: '号卡专区-在线选号',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/regular/template1/Index')
    },
    {
      path: '/regular/template1/:productId',
      name: 'regular-detail',
      meta: {
        title: '号卡在线办理',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/regular/template1/Detail')
    },
    {
      path: '/regular/template1/:productId/:agentId',
      name: 'regular-detail',
      meta: {
        title: '号卡在线办理',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/regular/template1/Detail')
    },
    {
      path: '/regular/template2',
      name: 'regular',
      meta: {
        title: '号卡专区-在线选号',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/regular/template2/Index')
    },
    {
      path: '/regular/template2/:groupId',
      name: 'regular-detail',
      meta: {
        title: '号卡在线办理',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/regular/template2/Detail')
    },
    {
      path: '/regular/template2/:groupId/:agentId',
      name: 'regular-detail',
      meta: {
        title: '号卡在线办理',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/regular/template2/Detail')
    },
    {
      path: '/iot/:agentId',
      name: 'iot',
      meta: {
        title: '流量卡专区',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/iot/Index')
    },
    {
      path: '/iot/:id/:agentId',
      name: 'iot-detail',
      meta: {
        title: '在线领取',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/iot/Detail')
    },
    {
      path: '/pay/success',
      name: 'pay-success',
      meta: {
        title: '支付完成',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/PaySuccess')
    },
    {
      path: '/cert/CTCCcmp5G8385',
      name: 'cert-CTCCcmp5G8385',
      meta: {
        title: '实名认证',
        header: false,
        bottom: false,
        keepAlive: false,
        auth: false
      },
      component: () => import('@/card/views/cert/CTCCcmp5G8385')
    },
    ...template2
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js